import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiTrashCanOutline } from "@mdi/js";

import { Grid } from "../../../../components/Grid";
import { Button } from "../../../../components/Button";

const LayerStyle = styled.div`
    display: ${props => (props.$show ? "flex" : "none")};
`;

export const MeasureLayer = props => {
    const { plot, show } = props;

    const layerName = "measureLayer";

    const [selected, setSelected] = useState();

    useEffect(() => {
        const layer = plot.addLayer(layerName, 130);
        const feature = plot.applyLineFeature(layer, "green", false);
        feature.onSetText((dist, angle) => dist.toFixed(2) + "m   " + angle.toFixed(2) + "°");
        feature.onSelect(line => setSelected(line));
    }, []);

    useEffect(() => {
        if (show) {
            plot.getLayer(layerName).activate();
        }
    }, [show]);

    const onDelete = () => {
        plot.getLayer(layerName).removeObject(selected);
    };

    useEffect(() => {
        const handleKeyDown = e => {
            if (!selected) {
                return;
            }
            if (e.key === "Delete" || e.key === "Backspace") {
                onDelete();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [selected]);

    return (
        <LayerStyle $show={show}>
            <Grid columns="1">
                <Button
                    svgIcon={mdiTrashCanOutline}
                    disabled={!selected}
                    onClick={() => onDelete()}
                    value={intl.get("common.delete")} />
            </Grid>
        </LayerStyle>
    );
};